import { useEffect, useState } from 'react';

import { MessageInstance } from 'antd/es/message/interface';
import { useTranslation } from 'react-i18next';

import { ApiErrorData } from 'models/ApiResponse';
import { Country } from 'models/Country';

import { CountryService } from 'services/CountryService';

interface UseCompanyMetadataParams {
  message: MessageInstance;
}

interface UseCompanyMetadataReturn {
  countries: Country[];
  tableLoading: boolean;
  setTableLoading: (loading: boolean) => void;
}

export function useCompanyMetadata({
  message,
}: UseCompanyMetadataParams): UseCompanyMetadataReturn {
  const { t } = useTranslation();

  const [countries, setCountries] = useState<Country[]>([]);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    loadMetadata();
  }, []);

  const loadMetadata = async () => {
    await loadCountries();
  };

  const loadCountries = async () => {
    const response = await CountryService.getAll();

    if (response.success) {
      setCountries(response.data as Country[]);
    } else {
      const error = response.data as ApiErrorData;
      message.error(
        (error.message as string) ||
          t('scenes.settings.companies.scene.errors.fetch_countries'),
        3.5
      );
    }
  };

  return {
    countries,
    tableLoading,
    setTableLoading,
  };
}
